import styled from 'styled-components';
import * as Tabs from '@radix-ui/react-tabs';
import { FONT_PROPERTIES } from 'common/components/TouchpointEditor/components/TouchpointContainer';

export const StyledTabsTrigger = styled(Tabs.Trigger)`
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 0.5rem;
    border-color: inherit;
    background-color: inherit;
    border-width: 0;
    ${FONT_PROPERTIES}
    &:hover {
        cursor: pointer;
    }
    &[data-state='active'],
    :hover {
        border-bottom: 2px solid;
        color: ${(props) => props.$fontColorActive};
        font-size: ${(props) => props.$fontSizeActive}px;
        font-family: '${(props) => props.$fontFamilyActive}', sans-serif;
    }
`;

export const StyledTabsList = styled(Tabs.List)`
    display: flex;
    justify-content: left;
    gap: 1rem;
    padding: 0px 1rem;
    width: 100%;
    max-width: 770px;
`;
